import React from "react";
import Avaliablemeals from "./Avaliablemeals";
import MealsSummary from "./MealsSummary";

const Meals = () => {
  return (
    <>
      <MealsSummary></MealsSummary>
      <Avaliablemeals></Avaliablemeals>
    </>
  );
};

export default Meals;
